import type { Sprint } from '../../../model/types';
import type { SprintsFetchStatus } from '../../reducers/entities/sprints/types';
import type { State } from '../../types';

export const getSprints = (state: State): Sprint[] => state.entities.sprints.data;

export const getSprintFetchError = (state: State): Error | undefined =>
	state.entities.sprints.fetchError;

export const getSprintFetchStatus = (
	state: State,
): (typeof SprintsFetchStatus)[keyof typeof SprintsFetchStatus] =>
	state.entities.sprints.fetchStatus;

export const getSprintFetchProgress = (state: State): number =>
	state.entities.sprints.fetchProgress;

export const getSprintFetchProgressUpdate = (state: State): string | undefined =>
	state.entities.sprints.fetchProgressUpdate;
